import { api } from '../client'
import { ENDPOINTS } from '../config'
import { ParentRecord } from '../types'

export interface NewCoParentPayload {
    firstName: string
    lastName: string
    email: string
    password: string
    phoneNumber: string
    relationship: string
    role?: string
    branch: string
    picture?: string
    [key: string]: unknown
}

export const CoParentsService = {
    me: () => api.get<ParentRecord | null>(ENDPOINTS.CO_PARENTS.ME),

    /** Link an existing parent as the current user's co-parent. */
    linkExisting: (coParentId: string) =>
        api.post<unknown>(ENDPOINTS.CO_PARENTS.ME, { coParentId }),

    /** Create a brand-new parent account and link it as co-parent. */
    createNew: (payload: NewCoParentPayload) =>
        api.post<unknown>(ENDPOINTS.CO_PARENTS.ME_NEW, {
            role: 'parent',
            ...payload
        }),

    unlink: () => api.delete<unknown>(ENDPOINTS.CO_PARENTS.ME)
}
